import MaterialTypography from "../../../../__snowpack__/pkg/@mui/material/Typography.js";
import React from "react";
import Icon from "../../atoms/icon/icon.component.js";
import {EmptyStateContainer} from "./merge-unit-empty-state.styles.js";
function MergeUnitEmptyState({
  icon,
  content,
  direction
}) {
  return /* @__PURE__ */ React.createElement(EmptyStateContainer, {
    direction
  }, /* @__PURE__ */ React.createElement(Icon, {
    size: "large"
  }, icon), /* @__PURE__ */ React.createElement(MaterialTypography, {
    variant: "h6"
  }, content));
}
export default /* @__PURE__ */ React.memo(MergeUnitEmptyState);
